import styled from 'styled-components';

import { CONTAINER_PADDING } from "../const/sizes";
import { device } from '../const/device';
import { ColorPicker } from './Global';
import { SECONDARY_COLOR } from '../const/color';


export const StartPageContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: ${CONTAINER_PADDING}px;

  @media (${device.tablet}) {
    padding: ${CONTAINER_PADDING / 2}px ${CONTAINER_PADDING}px;
    height:auto;
  }
`;

export const BaseContainer = styled.div`
  position: relative;
  width: 100vw;
  //height: 100vh;
  //overflow: hidden;
  padding: ${CONTAINER_PADDING}px;
  
  @media (${device.tablet}) {
    padding: ${CONTAINER_PADDING / 2}px ${CONTAINER_PADDING}px;
    min-height:100vh;
    overflow-x:hidden;
    overflow-y:auto;
    height:auto;
  }
  @media (${device.mobileL}) {
    padding: 16px;
    height:auto;
  }
`;

export const NotActiveContent = styled.div`
  width:100vw;
  height:100vh;
  position:absolute;
  z-index:100;
  left:0;
  top:0;

`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  //height: 100%;
  
  @media (${device.tablet}) {
    flex-direction: column;
    min-height: calc(100vh - 82px);
    height:auto;
  }
  
  @media (${device.mobileL}) {
    min-height: calc(100% - 32px);
    height:auto;
  }
`;

export const InfoContainer = styled.div`
  background: white;
  position: absolute;
  z-index: 6;
  width: 100%;
  min-height:100%;

  @media(${device.tablet}){
    margin-left: -32px;
    padding: 15px 32px;
  }

  @media(${device.mobileL}){
    margin-left: -15px;
    margin-top:-48px;
    padding: 63px 15px 15px 15px;
  }
`;

export const ShareContainer = styled.div`
  background: white;
  position: absolute;
  z-index: 8;
  width:360px;
  display: flex;
  flex-direction: row-reverse;
  padding: 5px;
  border-radius:4px;
  transform: translate(-50%, 0px);
  left: 50%;
  top: 25%;

  justify-content:space-between;

  @media(${device.tablet}){
    width:560px;
  }

  @media(${device.tabletS}){
    width:360px;
  }

  @media(${device.mobileM}){
    width:320px;
  }
`;

export const ShareCloseBtnContainer = styled.div`
  position:absolute;
`

export const ScreenContainer = styled.div`
  margin-left: 64px;
  margin-top: 48px;
  flex: 0 0 auto;
  width: 416px;
  position: relative;
  height: auto;

  @media (${device.laptopS}) {
    margin-left: 34px;
  }
  
  @media (${device.tablet}) {
    width: 100%;
    margin-left: 0;
    margin-top: 40px;
    min-height:35vh;
    height:auto;
  }
  
  @media (${device.mobileL}) {
    margin-top: 32px;
    min-height:35vh;
    height:auto;
    display: flex;
    flex-direction: column;
  }
  
  &.screen-enter {
    opacity: 0.01;
  }
  &.screen-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-out;
  }
  &.screen-exit {
    opacity: 1;
  }
  &.screen-exit-active {
    opacity: 0;
    transition: opacity 300ms ease-out;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 0;
  display: flex;
  z-index: 2;
  
  @media (${device.tablet}) {
    height: 50px;
  }
  @media (${device.mobileL}) {
    height: 32px;
  }
`;

export const HeaderIconContainer = styled.div`
  margin-left: auto;
  margin-top:  -14px;
  z-index:200;
  > * {
    margin-left: 32px;
  }
  
  @media (${device.tablet}) {
    display: none;
  }
`
export const SwitchWrap = styled.div`
    position: relative;
    display: inline-block;
`;

export const SwitchLabel = styled.label<{position: string}>`
  position: ${props => props.position};
  top: 0;
  left: 0;
  width: 43px;
  height: 23px;
  border-radius: 50px;
  background: #000;
  padding: 2px;
  border: 1px solid #000;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 17px;
    height: 17px;
    border: 1px solid #000;
    background: #ffffff;
    transition: 0.2s;
  }
`;
export const SwitchBox = styled.input.attrs(props => (
    {
        id: 'checkbox',
        type: 'checkbox',
        checked: (props.id == "black")?true:false
    }))<{ id: string, type: string}>`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 40px;
  height: 23px;
  &:checked + ${SwitchLabel} {
    background: #10cba5;
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 17px;
      height: 17px;
      margin-left: 20px;
      transition: 0.2s;
      background: transparent;
    }
    &::before{
      content: "";
      position: absolute;
      left: 72%;
      width: 9px;
      height: 16px;
      background: black;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      border-left: none;
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  height: 0;
  display: flex;
  position:sticky;
  bottom:25px;
  
  @media (${device.tablet}) {
    display: none;
  }
`;


export const FooterIconContainer = styled.div`
  margin-top: -24px;
  margin-right: auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  
  > * {
    margin-right: 18px;
  }
`


export const ColorContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 34px;
  //height: 80%;
  top: 34px;
  right: 34px;
  
  > ${ColorPicker.Item} {
    margin-bottom: 30px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  @media (${device.mobileL}) {
    top: auto;
    right: auto;
    left: 34px;
    bottom: 34px;
    z-index: 6;
  }
`;

export const MemberContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items:center;
  width: auto;
  height: calc(100% - 75px);
  top: 34px;
  right: 34px;
  
  > div {
    &:last-child {
      margin-bottom: 0;
    }
  }

  @media(${device.tablet}){
    top: 50px;
    right: 5px;
  }
`;

export const MemberList = styled.div`
    max-height: calc(100% - 50px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-top:10px;
    margin-bottom:10px;

    &::-webkit-scrollbar {
      width:3px;
    }
  
    &::-webkit-scrollbar-thumb {
      background:#e4e4e4;
    }
`;
